// Mock Data for Trendora - Fashion Aggregator

export const heroData = {
  brandName: "TRENDORA",
  tagline: "Explore the future of affordable fashion where style meets savings.",
  code: "TR-2025SS0742",
  heroImage: "https://images.unsplash.com/photo-1723734820800-89bc7309acf3?w=1400&q=80",
  secondaryImage: "https://images.unsplash.com/photo-1759646881002-33ce4a8bf3d6?w=800&q=80"
};

export const aboutData = {
  headline: "Embark on a style revolution where premium fashion becomes accessible to all, curated from the best sources worldwide.",
  description: "Inspired by the belief that great style shouldn't come with a premium price tag, we aggregate the finest fashion pieces from hundreds of global retailers, bringing you curated collections at unbeatable prices.",
  marqueeText: "a celebration of style curated from the world's best brands, bringing you premium fashion at prices that redefine the essence of smart shopping."
};

export const collections = [
  {
    id: 1,
    number: "001",
    name: "Streetwear Culture",
    subtitle: "Urban Expression",
    image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800&q=80",
    slug: "streetwear",
    gender: "unisex"
  },
  {
    id: 2,
    number: "002",
    name: "Formal Elegance",
    subtitle: "Refined Sophistication",
    image: "https://images.unsplash.com/photo-1714328564923-d4826427c991?w=800&q=80",
    slug: "formal",
    gender: "men"
  },
  {
    id: 3,
    number: "003",
    name: "Luxury Redefined",
    subtitle: "Premium for Less",
    image: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?w=800&q=80",
    slug: "luxury",
    gender: "women"
  },
  {
    id: 4,
    number: "004",
    name: "Athleisure Fusion",
    subtitle: "Move in Style",
    image: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7?w=800&q=80",
    slug: "athleisure",
    gender: "unisex"
  },
  {
    id: 5,
    number: "005",
    name: "Casual Essentials",
    subtitle: "Everyday Elevated",
    image: "https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800&q=80",
    slug: "casual",
    gender: "men"
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: "Oversized Graphic Tee",
    brand: "ZARA",
    original_price: 45.99,
    sale_price: 29.99,
    discount: 35,
    image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=400&q=80",
    category: "streetwear",
    source: "zara.com",
    gender: "unisex"
  },
  {
    id: 2,
    name: "Tailored Slim Blazer",
    brand: "H&M",
    original_price: 89.99,
    sale_price: 54.99,
    discount: 39,
    image: "https://images.unsplash.com/photo-1714328564923-d4826427c991?w=400&q=80",
    category: "formal",
    source: "hm.com",
    gender: "men"
  },
  {
    id: 3,
    name: "Minimalist Leather Bag",
    brand: "MANGO",
    original_price: 129.99,
    sale_price: 79.99,
    discount: 38,
    image: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?w=400&q=80",
    category: "luxury",
    source: "mango.com",
    gender: "women"
  },
  {
    id: 4,
    name: "Performance Joggers",
    brand: "NIKE",
    original_price: 75.00,
    sale_price: 49.99,
    discount: 33,
    image: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7?w=400&q=80",
    category: "athleisure",
    source: "nike.com",
    gender: "unisex"
  },
  {
    id: 5,
    name: "Relaxed Fit Denim",
    brand: "UNIQLO",
    original_price: 59.90,
    sale_price: 39.90,
    discount: 33,
    image: "https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=400&q=80",
    category: "casual",
    source: "uniqlo.com",
    gender: "men"
  },
  {
    id: 6,
    name: "Wool Blend Coat",
    brand: "COS",
    original_price: 199.00,
    sale_price: 119.00,
    discount: 40,
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=80",
    category: "luxury",
    source: "cos.com",
    gender: "women"
  },
  {
    id: 7,
    name: "Tech Fleece Hoodie",
    brand: "ADIDAS",
    original_price: 85.00,
    sale_price: 59.99,
    discount: 29,
    image: "https://images.pexels.com/photos/7741187/pexels-photo-7741187.jpeg?auto=compress&cs=tinysrgb&w=400",
    category: "athleisure",
    source: "adidas.com",
    gender: "men"
  },
  {
    id: 8,
    name: "Linen Summer Shirt",
    brand: "ASOS",
    original_price: 42.00,
    sale_price: 28.00,
    discount: 33,
    image: "https://images.pexels.com/photos/28994265/pexels-photo-28994265.jpeg?auto=compress&cs=tinysrgb&w=400",
    category: "casual",
    source: "asos.com",
    gender: "women"
  }
];

export const brands = [
  { id: 1, name: "ZARA", logo: "Z" },
  { id: 2, name: "H&M", logo: "H" },
  { id: 3, name: "NIKE", logo: "N" },
  { id: 4, name: "ADIDAS", logo: "A" },
  { id: 5, name: "UNIQLO", logo: "U" },
  { id: 6, name: "MANGO", logo: "M" },
  { id: 7, name: "COS", logo: "C" },
  { id: 8, name: "ASOS", logo: "AS" },
  { id: 9, name: "& OTHER STORIES", logo: "&" },
  { id: 10, name: "MASSIMO DUTTI", logo: "MD" }
];

export const brandShowcase = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=400&q=80",
    name: "ZARA",
    platform: "zara.com"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1714328564923-d4826427c991?w=400&q=80",
    name: "H&M",
    platform: "hm.com"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?w=400&q=80",
    name: "MANGO",
    platform: "mango.com"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1606902965551-dce093cda6e7?w=400&q=80",
    name: "NIKE",
    platform: "nike.com"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=400&q=80",
    name: "UNIQLO",
    platform: "uniqlo.com"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=80",
    name: "COS",
    platform: "cos.com"
  },
  {
    id: 7,
    image: "https://images.pexels.com/photos/7741187/pexels-photo-7741187.jpeg?auto=compress&cs=tinysrgb&w=400",
    name: "ADIDAS",
    platform: "adidas.com"
  }
];

export const navLinks = [
  { label: "Collections", href: "#collections" },
  { label: "Featured", href: "#featured" },
  { label: "Brands", href: "#brands" },
  { label: "About", href: "#about" }
];
